module.exports = __webpack_public_path__ + "984f5ca42e0d8c06b298388b9de96fd8.MP3";